jQuery(document).ready(function($) {
    'use strict';

    var windowWidth = $(window).outerWidth();

    const isExpanded = function($container) {
        return $container.hasClass('cancellation-insurance--expanded');
    };

    $(document)
        .on(
            'click',
            '.cancellation-insurance .cancellation-insurance__toggle',
            function(e) {
                e.preventDefault();

                const $this = $(this);
                const $container = $this.closest('.cancellation-insurance');
                const $body = $(document.body);
                
                $(this).text(isExpanded($container) ? 'Läs mer' : 'Stäng');

                requestAnimationFrame(function() {
                    $container.get(0).scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                });

                $container.toggleClass('cancellation-insurance--expanded');

                if (windowWidth < 1024) {
                    var scrolltop = $body.attr('data-pos');
                    if (
                        !$container.hasClass('cancellation-insurance--expanded')
                    ) {
                        $('html, body').stop().animate({
                            'scrollTop': $container.offset().top + scrolltop,
                        }, 500);
                    } else {
                        $body.attr('data-pos', $(window).scrollTop());
                    }
                }
            },
        );
});
